
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Testimonials() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const [playingIndex, setPlayingIndex] = useState(null);

  const getVideoType = (url) => {
    if (!url) return null;
    if (url.includes("youtube.com") || url.includes("youtu.be")) return "youtube";
    if (url.includes("vimeo.com")) return "vimeo";
    if (url.endsWith(".mp4")) return "mp4";
    return null;
  };

  const getEmbedUrl = (url) => {
    const type = getVideoType(url);
    if (type === "youtube") {
      const match = url.match(/(?:youtu\.be\/|v=)([^&]+)/);
      return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    }
    if (type === "vimeo") {
      const match = url.match(/vimeo\.com\/(\d+)/);
      return match ? `https://player.vimeo.com/video/${match[1]}` : null;
    }
    return url; // for .mp4
  };

  const handleClick = (item, index) => {
    if (item.videoLink) {
      setPlayingIndex(playingIndex === index ? null : index);
    } else if (item.pdfLink) {
      window.open(item.pdfLink, "_blank");
    }
  };

  const testimonials = [
    {
      image: "/assets/img14.png",
      title: "Empowered Youth Success",
      description: "Meet Ribka, who found employment through our Program",
     videoLink: "https://www.dropbox.com/scl/fi/orm1mjh9h5rwhjn8fhs1f/IMG_6669.MP4?rlkey=htscm2475c6kuie4saxg1h3fe&raw=1"

    },
    {
      image: "/assets/soliyana.png",
      title: "Partnering for Potential: Heineken’s Journey with Dereja",
      description:
        "Soliyana, Talent Manager at Heineken, shares the company’s journey partnering with Dereja highlighting how the collaboration has supported youth employment, talent acquisition, and meaningful engagement with fresh graduates.",
      videoLink: "https://www.dropbox.com/scl/fi/16tvfo8sdv0701mx9b1ul/Dereja_Testimonial_Soliyana.mp4?rlkey=fqbx7lznxpshs2oe4jxxvet8j&raw=1",
    },
    {
      image: "/assets/daapgraduate.png",
      title: "Prepared and Confident: Biruktawit on the Power of DAAP",
      description:
        "Biruktawit Gezahegn, a DAAP graduate, shares her experience attending the job fair and emphasizes how the DAAP program equipped her with the confidence, skills, and mindset every fresh graduate needs before starting their career journey.",
      videoLink:"https://www.dropbox.com/scl/fi/829l0hgvq3z84cmhmhhoo/4th.mp4?rlkey=g70l7udwdr0hf7cp0dfsqg5vv&raw=1"
    },
    {
      image: "/assets/haymanot.png",
      title: "Once a Job Seeker, Now Hiring: Haymanot’s Inspiring Story",
      description:
        "Haymanot Abereham, now a Talent Specialist at JTI (National Tobacco Enterprise), shares her inspiring journey from participating in the 2021 Job Fair at Hawassa University as a job seeker to returning in 2022 as an employer representing her company. A true testament to growth, opportunity, and the power of career fairs.",
      videoLink: "https://www.youtube.com/watch?v=ZMCNbYFHhNM",
    },
    {
      image: "/assets/employert.png",
      title: " Employer Perspective on the Annual Career Expo ",
      description: "Nebiyu Admasu shares insights on the impact and success of the Annual Career Expo",
      videoLink: "https://www.youtube.com/watch?v=_7cao4M4gFI&t=1s",
    },
    {
      image: "/assets/candidatet.png",
      title: "Hawassa University Student on the Annual Career Expo",
      description: "Wolde Gebriel Nega, a student from Hawassa University, shares his thoughts on the Annual Career Expo experience.",
      videoLink: "https://www.dropbox.com/scl/fi/lhsfn25omqultl79krbh3/Hwt.mp4?rlkey=qsm6e9fwrizokx27wpl4xx9x6&raw=1",
    },
    {
      image: "/assets/dap.png",
      title: "Training Journey Testimonial",
      description: "A testimonial from a Dereja Academy trainee reflecting on their growth during the Accelerated Training Program.",
      videoLink: "https://www.youtube.com/watch?v=anmVD4btVYw",
    },
    {
      image: "/assets/Jobfair.jpg",
      title: "JobFair Testimonial",
      description: "Attending the Job Fair was a game-changer for me! It gave me the opportunity to connect directly with employers, understand what they’re looking for, and even secure interviews on the spot. ",
      videoLink: "https://www.dropbox.com/scl/fi/zbme736d3fljzhsi4f6ej/DerejaAnnualJobFair2019.mp4?rlkey=0sjwcgvs78gvr8pktq8ku77mx&st=2dsi86xu&raw=1",
    },
    {
      image: "/assets/habtamutst.png",
      title: "Empowering Career Development in Universities:CDC Perspective",
      description: "Habtamu, a CDC Coordinator, shares how Dereja has strengthened university Career Development Centers (CDCs) through consistent support, capacity-building trainings, and collaborative engagement.",
      videoLink: "https://www.dropbox.com/scl/fi/i681aex08991q4olojnmi/Dereja_Testimonial_Habtamu.mp4?rlkey=ztssn649pqluqhvddhqg4f07m&st=rbgkw42l&raw=1",
    },
    {
      image: "/assets/peopleinneed.png",
      title: "Why Job Fairs Matter: A Recruiter’s Perspective",
      description:
        "A representative from People in Need shares how job fairs play a vital role in connecting fresh graduates with potential employers. They highlight the clear difference observed between candidates who went through Dereja’s programs and those who didn’t — emphasizing the value of career preparation and structured support.",
      videoLink: "https://www.youtube.com/watch?v=AR-zIqFuek8",
    },
    {
      image: "/assets/tst.png",
      title: "Dereja’s Role in National Career Development",
      description:
        "The CDC Director of Addis Ababa Science and Technology University (AASTU) reflects on the success of the 2021 Career Expo, praising its strong organization and real hiring outcomes.",
      videoLink: "https://www.dropbox.com/scl/fi/bbhwptni6dz7wstmgrsdf/5th.mp4?rlkey=z2nack8bqsohsciir8qrhsnk4&st=834s34om&raw=1",
    },
    {
      image: "/assets/airlines.png",
      title: "From Preparation to Performance: Dereja Graduates Shine at Expo",
      description:
        "A recruiter from Ethiopian Aviation Academy shares their first-time experience participating in the National Career Expo. They highlight the noticeable difference between Dereja-trained candidates and others—emphasizing the professionalism, confidence, and preparedness of those who underwent Dereja’s career readiness training.",
      videoLink: "https://www.dropbox.com/scl/fi/5jethx94zw8ahv4y7oxv4/Airlines.mp4?rlkey=r73t04p4gtrb8lju98upbwst5&raw=1",
    },
    {
      image: "/assets/eden.png",
      title: "How Dereja Prepared Me for the Career Expo: Eden Mulu’s Story",
      description:
        "Eden Mulu, a recent graduate, shares her experience participating in the National Career Expo. She highlights how Dereja’s training helped her improve her CV, develop strong communication skills, and present herself professionally to employers giving her the confidence to stand out and make meaningful connections.",
      videoLink: "https://www.dropbox.com/scl/fi/htbonx8s95rgzzdr8aykl/EdenMuluGraduateStudent.mp4?rlkey=ke88x6ielc6k9luk1mljvwgn7&st=fria5n3y&raw=1",
    },
    {
      image: "/assets/someone.png",
      title: "Well-Prepared Graduates Impress Dashen Bank at Job Fair",
      description:
        "A recruiter from Dashen Bank shares their positive experience at the Dereja Job Fair, noting a significant improvement in the quality of CVs received. Compared to previous encounters with fresh graduates, they found the job fair more efficient and appreciated the professionalism and organization of candidates’ applications.",
       videoLink:"https://www.dropbox.com/scl/fi/8f0za15zr6ujdatbzd3v3/BehailuGizachewEmployer.mp4?rlkey=jmokii29dvjfwyrqm6xq647wz&st=2cixr7lt&raw=1" },
    {
      image: "/assets/candidate2.png",
      title: "Beniam Negash Praises Dereja for Connecting Graduates to Real Opportunities.",
      description:
        "Beniam Negash, a recent graduate and job fair participant, shares his satisfaction with the Dereja-organized event. He was excited to see the promised companies in attendance and had the opportunity to apply to many of them. He appreciates how Dereja is equipping fresh graduates with the tools and opportunities they need to succeed in today’s job market.",
      videoLink: "https://www.youtube.com/watch?v=k7lKo4H-QFY",
    },
    {
      image: "/assets/candidate1.png",
      title: "When Promises Meet Opportunity",
      description:
        "Graduates found the companies they were told would attend and got the chance to apply on the spot. Many walked away impressed by how well-prepared and opportunity-ready the experience made them feel.",
      videoLink: "https://www.dropbox.com/scl/fi/7p8ok1scm2cbyeqpzykzx/Candidate3.mp4?rlkey=pz2g8wz4xvct8r2s4eet5837j&st=fn2bj4uo&raw=1",
    },
    {
      image: "/assets/wateraid.png",
      title: "Trained by Dereja. Now Recruiting Through Dereja",
      description:
        "A former trainee, now back as a recruiter, credits Dereja for launching her career. Returning to the job fair as an employer, she’s a living example of the platform’s real impact on fresh graduates.",
      videoLink: "https://www.dropbox.com/scl/fi/a4z9one0g8xrwn3uhdlyq/HermelatameneEmployer.mp4?rlkey=hb08hfe8fjdepenxg66xo6oqq&st=dspiglme&raw=1",
    },
    {
      image: "/assets/buna.png",
      title: "Trained Graduates, Real Value for Employers",
      description:
        "A company recruiter spent the day screening and interviewing graduates at the job fair. Having access to well-trained candidates made the experience more efficient — and valuable — for their hiring needs.",
        videoLink: "https://www.dropbox.com/scl/fi/utfetupwqvxq25h2zhpc5/YenesewTamiruEmployer.mp4?rlkey=bwvneww68pf0wjyh471xbl9yp&raw=1",
    },
  ];

  return (
    <div className="min-h-screen bg-white px-6 py-10">
      <button
        onClick={() => navigate(-1)}
        className="text-[#fa5d15] font-semibold mb-6"
      >
        ← Back
      </button>

      <h2 className="text-3xl font-bold text-[#fa5d15] mb-6">
        Testimonials & Impact Stories
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {testimonials.map((item, index) => {
          const videoType = getVideoType(item.videoLink);
          const embedUrl = getEmbedUrl(item.videoLink);

          return (
            <div
              key={index}
              onClick={() => handleClick(item, index)}
              className="cursor-pointer bg-gray-100 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              {item.videoLink && playingIndex === index ? (
                videoType === "mp4" ? (
                  <video
                    src={item.videoLink}
                    controls
                    autoPlay
                    className="w-full h-48 object-cover"
                  />
                ) : (
                  <iframe
                    src={embedUrl}
                    className="w-full h-48"
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    title={`Video ${index}`}
                  />
                )
              ) : (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
              )}

              <div className="p-4">
                <h3 className="text-lg font-bold text-gray-800">{item.title}</h3>
                <p className="text-sm text-gray-600 mt-2">{item.description}</p>
                <p className="mt-2 text-sm text-[#fa5d15] font-medium">
                  {item.videoLink ? "Tap to Play Video →" : "View Full Story →"}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
